<app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="loadData($event)"></app-pesquisa>

<app-relatorio-container
    tituloRelatorio="Ofício de Cancelamento de Inscrição Secundária"
    descricaoRelatorio="Ofício comunicando cancelamento de inscrição secundária ao CRM de origem"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'oficio-confirmacao-cancelamento-inc-secundaria-medico.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <p class="text-sm text-muted-color">O ofício será emitido para o médico selecionado, comunicando ao CRM de inscrição principal que ele(a) solicitou o cancelamento de sua inscrição secundária neste Conselho.</p>

            <app-card-medico-selecionado [pessoa]="pessoa()" [pessoaResponse]="pessoaResponse()" (alterar)="showPesquisarPessoa()"></app-card-medico-selecionado>

            <div class="field">
                <label for="conselhoDestino" class="font-semibold block mb-2">CRM de inscrição principal (opcional)</label>
                <input id="conselhoDestino" type="text" pInputText formControlName="conselhoDestino" class="w-full" placeholder="Ex.: CRM-SP (se não informado, o sistema tenta identificar automaticamente)" />
            </div>

            <div class="field">
                <label for="presidente" class="font-semibold block mb-2">Presidente destinatário (opcional)</label>
                <input id="presidente" type="text" pInputText formControlName="presidente" class="w-full" placeholder="Nome do(a) presidente do CRM de destino" />
            </div>

            <div class="field">
                <label for="emissor" class="font-semibold block mb-2">Emissor (opcional)</label>
                <input id="emissor" type="text" pInputText formControlName="emissor" class="w-full" placeholder="Nome do responsável pela emissão do documento" />
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button
                    label="Gerar Ofício"
                    icon="pi pi-file-pdf"
                    [appCan]="roleGerar"
                    (click)="gerarRelatorio()"
                    [loading]="isPending"
                    [disabled]="isPending || !possuiPessoaSelecionada"
                    pTooltip="Para gerar o relatório, selecione um médico."
                    tooltipPosition="top"
                    [tooltipDisabled]="possuiPessoaSelecionada"
                ></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
